export default __webpack_public_path__ + "static/media/memeory.a4bf727d.png";